import { Observable, throwError, BehaviorSubject } from "rxjs";
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError } from "rxjs/operators";
import { Timesheet } from "../components/timesheet/timesheet.model";
import { baseURL, VERSION } from "../constant/constant";
import { ResponseBase, ResponseForTimesheetList, type ResponseForReport } from "../constant/response";
import { UserReport } from "../constant/userReport";
import type { CategoryDTO } from "../components/category/category.model";
import type { CategoryReport } from "../constant/categoryReport";

@Injectable({
  providedIn: 'root'
})
export class TimesheetService {

  private pageSize = 10;
  private authToken = sessionStorage.getItem('authToken');

  private currentPageSubject = new BehaviorSubject<number>(0);
  private pageSizeSubject = new BehaviorSubject<number>(this.pageSize);

  currentPage$ = this.currentPageSubject.asObservable();
  pageSize$ = this.pageSizeSubject.asObservable();

  constructor(private http: HttpClient) { }

  // createTimesheet(timesheet: Timesheet): Observable<Timesheet> {
  //   return this.http.post<Timesheet>(`${baseURL}timesheets/${VERSION}`, timesheet, {
  //     headers: {
  //       Authorization: `Bearer ${this.authToken}`
  //     }
  //   }).pipe(
  //     catchError(this.handleError)
  //   );
  // }

  createTimesheet(timesheet: Timesheet): Observable<ResponseBase<Timesheet>> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.authToken}`
    });
    return this.http.post<ResponseBase<Timesheet>>(`${baseURL}timesheets/${VERSION}`, timesheet, {headers})
    .pipe(
      catchError(this.handleError)
    );
  }

  updateTimesheet(timesheet: Timesheet): Observable<ResponseBase<Timesheet>> {
    return this.http.put<ResponseBase<Timesheet>>(`${baseURL}timesheets/${VERSION}/updateTimesheet`, timesheet, {
      headers: {
        Authorization: `Bearer ${this.authToken}`
      }
    }).pipe(
      catchError(this.handleError)
    );
  }

  deleteTimesheet(id: number): Observable<ResponseBase<Timesheet>> {
    return this.http.delete<ResponseBase<Timesheet>>(`${baseURL}timesheets/${VERSION}/${id}`, {
      headers: {
        Authorization: `Bearer ${this.authToken}`
      }
    }).pipe(
      catchError(this.handleError)
    );
  }

  getTimesheetList(filters: any, page: number = 0, size: number = 10): Observable<ResponseForTimesheetList<Timesheet>> {
    let params = new HttpParams()
      .set('pageNo', page.toString())
      .set('pageSize', size.toString());
    if (filters) {
      if (filters.userIds) {
        params = params.set('userIds', filters.userIds);
      }
      if (filters.workDate != '' && filters.workDate != null) {
        params = params.set('workDate', filters.workDate);
      }
      if (filters.activityIds) {
        params = params.set('activityIds', filters.activityIds);
      }
      if (filters.categoryIds) {
        params = params.set('categoryIds', filters.categoryIds);
      }
      if (filters.startDate != '' && filters.startDate != null) {
        const startDate = new Date(filters.startDate);
        params = params.set('startDate', filters.startDate);
      }
      if (filters.endDate != '' && filters.endDate != null) {
        const endDate = new Date(filters.endDate);
        params = params.set('endDate', filters.endDate);
      }
      if (filters.status) {
        params = params.set('status', filters.status);
      }
    }

    return this.http.get<ResponseForTimesheetList<Timesheet>>(`${baseURL}timesheets/${VERSION}/list`, {
      params,
      headers: {
        Authorization: `Bearer ${this.authToken}`
      }
    }).pipe(
      catchError(this.handleError)
    );
  }

  exportTimesheet(filters: any, userId: any): Observable<any> {
    let params = new HttpParams()
      .set('userId', userId.toString());

    if (filters) {
      if (filters.userIds) {
        params = params.set('userIds', filters.userIds);
      }
      if (filters.workDate != '' && filters.workDate != null) {
        params = params.set('workDate', filters.workDate);
      }
      if (filters.activityIds) {
        params = params.set('activityIds', filters.activityIds);
      }
      if (filters.categoryIds) {
        params = params.set('categoryIds', filters.categoryIds);
      }
      if (filters.startDate != '' && filters.startDate != null) {
        const startDate = new Date(filters.startDate);
        params = params.set('startDate', filters.startDate);
      }
      if (filters.endDate != '' && filters.endDate != null) {
        const endDate = new Date(filters.endDate);
        params = params.set('endDate', filters.endDate);
      }
      if (filters.status) {
        params = params.set('status', filters.status);
      }
    }

    return this.http.get<any>(`${baseURL}timesheets/${VERSION}/export`, {
      params,
      headers: {
        Authorization: `Bearer ${this.authToken}`
      }
    }).pipe(
      catchError(this.handleError)
    );
  }

  getCategoryReport(filters: any): Observable<ResponseForReport<CategoryReport>> {
    let params = new HttpParams();
    if (filters) {
      if (filters.userIds) {
        params = params.set('userIds', filters.userIds);
      }
      if (filters.workDate != '' && filters.workDate != null) {
        params = params.set('workDate', filters.workDate);
      }
      if (filters.activityIds) {
        params = params.set('activityIds', filters.activityIds);
      }
      if (filters.categoryIds) {
        params = params.set('categoryIds', filters.categoryIds);
      }
      if (filters.startDate != '' && filters.startDate != null) {
        const startDate = new Date(filters.startDate);
        params = params.set('startDate', filters.startDate);
      }
      if (filters.endDate != '' && filters.endDate != null) {
        const endDate = new Date(filters.endDate);
        params = params.set('endDate', filters.endDate);
      }
      if (filters.status) {
        params = params.set('status', filters.status);
      }
    }



    return this.http.get<ResponseForReport<CategoryReport>>(`${baseURL}timesheets/${VERSION}/categoryReport`, {
      params,
      headers: {
        Authorization: `Bearer ${this.authToken}`
      }
    }).pipe(
      catchError(this.handleError)
    );
  }

  exportCategoryReport(filters: any, userId: any): Observable<any> {
    let params = new HttpParams()
      .set('userId', userId.toString());

    if (filters) {
      if (filters.userIds) {
        params = params.set('userIds', filters.userIds);
      }
      if (filters.workDate != '' && filters.workDate != null) {
        params = params.set('workDate', filters.workDate);
      }
      if (filters.activityIds) {
        params = params.set('activityIds', filters.activityIds);
      }
      if (filters.categoryIds) {
        params = params.set('categoryIds', filters.categoryIds);
      }
      if (filters.startDate != '' && filters.startDate != null) {
        const startDate = new Date(filters.startDate);
        params = params.set('startDate', filters.startDate);
      }
      if (filters.endDate != '' && filters.endDate != null) {
        const endDate = new Date(filters.endDate);
        params = params.set('endDate', filters.endDate);
      }
      if (filters.status) {
        params = params.set('status', filters.status);
      }
    }

    return this.http.get<any>(`${baseURL}timesheets/${VERSION}/categoryReportExcel`, {
      params,
      headers: {
        Authorization: `Bearer ${this.authToken}`
      }
    }).pipe(
      catchError(this.handleError)
    );
  }

  getUserReport(filters: any): Observable<ResponseForReport<UserReport>> {
    let params = new HttpParams();
    if (filters) {
      if (filters.userIds) {
        params = params.set('userIds', filters.userIds);
      }
      if (filters.workDate != '' && filters.workDate != null) {
        params = params.set('workDate', filters.workDate);
      }
      if (filters.activityIds) {
        params = params.set('activityIds', filters.activityIds);
      }
      if (filters.categoryIds) {
        params = params.set('categoryIds', filters.categoryIds);
      }
      if (filters.startDate != '' && filters.startDate != null) {
        const startDate = new Date(filters.startDate);
        params = params.set('startDate', filters.startDate);
      }
      if (filters.endDate != '' && filters.endDate != null) {
        const endDate = new Date(filters.endDate);
        params = params.set('endDate', filters.endDate);
      }
      if (filters.status) {
        params = params.set('status', filters.status);
      }
    }

    return this.http.get<ResponseForReport<UserReport>>(`${baseURL}timesheets/${VERSION}/userReport`, {
      params,
      headers: {
        Authorization: `Bearer ${this.authToken}`
      }
    }).pipe(
      catchError(this.handleError)
    );
  }

  exportUserReport(filters: any, userId: any): Observable<any> {
    let params = new HttpParams()
      .set('userId', userId.toString());

    if (filters) {
      if (filters.userIds) {
        params = params.set('userIds', filters.userIds);
      }
      if (filters.workDate != '' && filters.workDate != null) {
        params = params.set('workDate', filters.workDate);
      }
      if (filters.activityIds) {
        params = params.set('activityIds', filters.activityIds);
      }
      if (filters.categoryIds) {
        params = params.set('categoryIds', filters.categoryIds);
      }
      if (filters.startDate != '' && filters.startDate != null) {
        const startDate = new Date(filters.startDate);
        params = params.set('startDate', filters.startDate);
      }
      if (filters.endDate != '' && filters.endDate != null) {
        const endDate = new Date(filters.endDate);
        params = params.set('endDate', filters.endDate);
      }
      if (filters.status) {
        params = params.set('status', filters.status);
      }
    }

    return this.http.get<any>(`${baseURL}timesheets/${VERSION}/userReportExcel`, {
      params,
      headers: {
        Authorization: `Bearer ${this.authToken}`
      }
    }).pipe(
      catchError(this.handleError)
    );
  }

  // updateTimesheet(id: number, timesheet: Timesheet): Observable<Timesheet> {
  //   return this.http.put<Timesheet>(`${baseURL}timesheets/${VERSION}/${id}`, timesheet, {
  //     headers: {
  //       Authorization: `Bearer ${this.authToken}`
  //     }
  //   }).pipe(
  //     catchError(this.handleError)
  //   );
  // }


  statusTimesheet(filters: any): Observable<any> {
    let params = new HttpParams()
      .set('userId', filters.userId.toString());

    if (filters) {
      if (filters.status != null || filters.status >= 0) {
        params = params.set('status', filters.status);
      }
      if (filters.ids) {
        params = params.set('ids', filters.ids);
      }
    }

    return this.http.get<any>(`${baseURL}timesheets/${VERSION}/status`, {
      params,
      headers: {
        Authorization: `Bearer ${this.authToken}`
      }
    }).pipe(
      catchError(this.handleError)
    );
  }

  setCurrentPage(page: number) {
    this.currentPageSubject.next(page);
  }

  setPageSize(size: number) {
    this.pageSizeSubject.next(size);
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An error occurred';
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      errorMessage = `Error: ${error.status}, Message: ${error.message}`;
    }
    return throwError(() => errorMessage);
  }
}
